import { render, staticRenderFns } from "./RememberPassword.vue?vue&type=template&id=bd8ae374&scoped=true"
import script from "./RememberPassword.vue?vue&type=script&lang=js"
export * from "./RememberPassword.vue?vue&type=script&lang=js"
import style0 from "./RememberPassword.vue?vue&type=style&index=0&id=bd8ae374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8ae374",
  null
  
)

export default component.exports